import React, { useEffect, useState } from "react";
import { Flex, Box, Button, useMediaQuery } from "@chakra-ui/react";
import ContactForm from "../../../../components/common/ContactForm";
import Intro from "../intro/Intro";
import formContent from "../../../../data/forms.json";
import { getHomeVideos } from "../../../../services/webService";

function About({ homepage = true }) {
  const formDescription = formContent.contactFormDescription;
  const [isMobile] = useMediaQuery("(max-width: 425px)");
  const [video, setVideo] = useState({});

  const handleButtonClick = () => {
    const element = document.getElementById("MakeContact");
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 50,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const fetchHomeVideos = async () => {
      try {
        const videos = await getHomeVideos();
        if (videos.length > 0) {
          setVideo(videos[1]);
        }
      } catch (error) {
        console.error("Error while trying to get video:", error);
      }
    };
    fetchHomeVideos();
  }, []);

  return (
    <Box
      className="about-container"
      position="relative"
      width="100%"
      height={{
        xs: homepage ? "75vh" : "80vh",
        s: homepage ? "56vh" : "65vh",
        md: homepage ? "138dvh" : "135dvh",
        lg: homepage ? "120dvh" : "125dvh",
        xl: homepage ? "115dvh" : "115dvh",
        desktop: homepage ? "105vh" : "105vh",
        xxl: homepage ? "100vh" : "100vh",
      }}
      bgImage="url('https://leadguitar.s3.eu-north-1.amazonaws.com/images/about.jpeg')"
      bgSize="cover"
      bgPosition="center"
      bgRepeat="no-repeat"
      zIndex="0"
      dir="ltr"
    >
      <Flex
        className="content"
        p={4}
        align="center"
        justify="center"
        position="relative"
        zIndex="1"
      >
        <Flex
          direction={{ base: "column", md: "row" }}
          width="100%"
          justify="space-around"
        >
          <Box
            order={{ base: 2, md: 1 }}
            width={{ base: "100%", md: "50%", lg: "60%", xl: "45%" }}
            position="relative"
            display="flex"
            mt={{ md: "1rem", lg: "0rem" }}
            justifyContent="center"
          >
            {isMobile ? (
              <Button
                bg="#0e7f2a"
                _hover={{ bg: "#42e362" }}
                color="#ffffff"
                onClick={handleButtonClick}
                dir="rtl"
              >
                לקביעת שיעור הניסיון הראשון שלי
              </Button>
            ) : (
              <ContactForm
                height={{
                  base: "100%",
                  md: "97%",
                  lg: homepage ? "94%" : "83%",
                  xl: homepage ? "92%" : "82%",
                  desktop: homepage ? "90%" : "78%",
                  xxl: "80%",
                }}
                width={{ base: "100%", md: "100%" }}
                description={formDescription}
              />
            )}
          </Box>
          <Box
            order={{ base: 1, md: 2 }}
            width={{ base: "100%", md: "50%" }}
            mb={{ md: "16%" }}
          >
            <Intro homepage={homepage} video={video} />
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
}

export default About;
